import {
  Box,
  Grid,
  Typography,
  Chip,
  Avatar
} from "@mui/material";
import { useState } from "react";
import ChangeHistoryIcon from "@mui/icons-material/ChangeHistory";
import CustomDialog from "../../common/dialog/CustomDialog"
import SSPEmailViewer from "./SSPEmailViewer";
import BasicButton from "../../common/button/BasicButton";
import Tooltip from '@mui/material/Tooltip';
import moment from "moment";
import { ConvertZ } from "../../../components/helpers/helperFunctions";
import RichEmailPreviewer from "../../../components/common2/RichEmailPreviewer";
import { IncomingEmailIcon, OutgoingEmailIcon } from "../../../components/common/svgIcons/chartIcon"
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ImageIcon from "@mui/icons-material/Image";
import DescriptionIcon from "@mui/icons-material/Description";
import timeSpanToReadbleFormat from "../../../util/timeSpanToReadbleFormat";
import DOMPurify from "dompurify";
const isHTML = (str: string) => {
  if (!str) return false;
  return /<\/?[a-z][\s\S]*>/i.test(str);
};

function isHTMLString(str: string): boolean {
  if (!str) return false;
  const doc = new DOMParser().parseFromString(str, "text/html");
  return Array.from(doc.body.childNodes).some(
    (node) => node.nodeType === 1 
  );
}
interface DescriptionViewerProps {
  value: string;
}
function convertDateFormat(inputDate: any) {
  const parsedDate = new Date(inputDate);

  if (isNaN(parsedDate.getTime())) {
    return "Invalid Date";
  }

  const year = parsedDate.getFullYear();
  const month = ("0" + (parsedDate.getMonth() + 1)).slice(-2);
  const day = ("0" + parsedDate.getDate()).slice(-2);
  const hours = ("0" + (parsedDate.getHours() % 12 || 12)).slice(-2);
  const minutes = ("0" + parsedDate.getMinutes()).slice(-2);
  const seconds = ("0" + parsedDate.getSeconds()).slice(-2);

  const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.000Z`;

  return formattedDate;
}
function parseDateString(inputString: any) {
  const inputTimeString = inputString;

  const dateRegex = /\{([^}]+)\}/g;

  const resultString = inputTimeString.replace(
    dateRegex,
    (match: any, dateStr: any) => {
      const convertedDate = convertDateFormat(dateStr);

      // console.log("outputTime", inputString, convertedDate);

      const localTime = moment(convertedDate).format("L LT");
      // const localTime = moment(utcDate).format("L LT");
      return localTime;
    }
  );

  return resultString;
}
const DescriptionViewer: React.FC<DescriptionViewerProps> = ({ value }) => {
  if (isHTMLString(value)) {
    return (
      <Box  sx={(theme) => ({
                backgroundColor: 'inherit', 
                '& .elementToProof': {
                color: `${theme.palette.text.primary} !important`, 
                backgroundColor: "transparent !important", 
                },
                "& .elementToProof span": {
                color: `${theme.palette.text.primary} !important`, 
                backgroundColor: "transparent !important", 
              },            
                   
            })}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(value),
        }}
      />
    );
  }

  return (
    <Typography sx={{ p: 1, whiteSpace: "pre-line" }}>
      {value&&parseDateString(value) || "—"}
    </Typography>
  );
};
const getRelativeTime = (date: any) => {
  const now = moment();
  const input = moment.utc(date).local()
  input.fromNow();
  const seconds = now.diff(input, "seconds");
  const minutes = now.diff(input, "minutes");
  const hours = now.diff(input, "hours");
  const days = now.diff(input, "days");

  if (seconds < 10) return "just now";
  if (seconds < 60) return `${seconds} seconds ago`;
  if (minutes === 1) return "1 minute ago";
  if (minutes < 60) return `${minutes} minutes ago`;
  if (hours === 1) return "1 hour ago";
  if (hours < 24) return `${hours} hours ago`;
  if (days === 1) return "1 day ago";
  if (days < 30) return `${days} days ago`;

  return input.fromNow();
};

const getAvatarText = (item: any) => {
  const type = item.userType?.toLowerCase();

  if (type === "businessrule") return "BR";
  if (type === "workflow") return "WF";
  let name = item.updatedBy ?? item.contactName;
  if (name) {
    const parts = name.split(" ");
    // if (parts.length > 1) {
    //   return (parts[0][0] + parts[1][0]).toUpperCase();
    // }
    return parts[0][0].toUpperCase();
  }

  return "U";
};

const SSPTimeline = ({ data  }: any) => {
  const [showticketlog,setShowticketLog] = useState<any>(false);
  const [selectedLog,setSelectedLog] =  useState<any>(null);
  const [showemailLog,setShowEmailLog] =  useState<any>(false);
  const [selectedEmailLog,setSelectedEmailLog] = useState<any>(null);
  
  if (!data || data.length === 0) {
    return (
      <Box sx={{ py: 4, textAlign: "center" }}>
        <Typography variant="body2" color="text.secondary">
          No Logs For The Ticket
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      {showticketlog && (
        <CustomDialog
          heading={`Change log`}
          body={
            <>
              <div>
                {selectedLog?.ticketLogChanges?.length > 0 ? (
                  selectedLog?.ticketLogChanges?.map((item: any) => {
                    return (
                      <ul>
                       <li>{<DescriptionViewer value={item?.Changes} />}</li>
                       
                      </ul>
                    );
                  })
                ) : (
                  <p>There is no changes made</p>
                )}
              </div>
            </>
          }
          open={showticketlog}
          handleClose={() => {
            setShowticketLog(false);
          }}
          footer={
            <>
              {" "}
              <BasicButton
                onClick={() => {
                  setShowticketLog(false);
                }}
                type="submit"
                label={"OK"}
                isLoading={false}
                isDisabled={false}
                color="primary"
                size="large"
                variant={"contained"}
                endIcon={false}
              />
            </>
          }
        />
      )}
      {showemailLog && (
       <SSPEmailViewer data={selectedEmailLog}  
       onClose={() => setShowEmailLog(false)}
       />
      )

      }
      {data?.map((item: any,index:number) => {
       let content = "";

        if (index === data.length - 1) {
          content = item.body?.trim()
            ? item.body
            : item.description ?? "";
        }

        return (
          <Grid
            container
            key={item.id}
            spacing={2}
            sx={{ mb: 1, mt:0.5, px: { xs: 1, md: 0 } }}
          >
            <Grid item xs={12} md={3.5} sx={{ display: "flex",borderRight: { md: "1px solid lightgray", xs: "none" } }}>
              <Box
                display="flex"
                position="relative"
                width="100%"
              >
                <Box
                  sx={{
                    position: "absolute",
                    left: 5,
                    top: 20,
                    bottom: 0,
                    width: "2px",
                    backgroundColor: "lightgray",
                  }}
                />

                <Box
                  sx={{
                    width: 12,
                    height: 12,
                    borderRadius: "50%",
                    backgroundColor: "#1976d2",
                    mt: 0.6,
                    mr: 2,
                    zIndex: 1,
                    flexShrink: 0,
                  }}
                />

                <Box>
                  <Typography variant="body2" sx={{mb:1}}>
                    {getRelativeTime(item.createdDateTime)}
                    {(item?.type === "Outgoing" || item?.type === "Incoming") && (
                     <>
                        {item?.type === "Outgoing" && (
                          <Tooltip title="Outgoing Mail" placement="right" arrow>
                            <span  style={{ display: "inline-flex", cursor: "pointer",marginLeft:'30px' }} 
                            onClick={() => {
                                setShowEmailLog(true);
                                setSelectedEmailLog(item);
                              }}
                            >
                             
                              <OutgoingEmailIcon
                                color={
                                  item?.isMessageSuccess
                                    ? "#09a44d"
                                    : "#ea0900"
                                }
                              />
                            </span>
                            </Tooltip>
                          
                        ) }
                        {item?.type === "Incoming" && (
                          <Tooltip title="Inoming Mail" placement="right" arrow>
                            <span  style={{ display: "inline-flex", cursor: "pointer",marginLeft:'30px' }} 
                             onClick={() => {
                                setShowEmailLog(true);
                                setSelectedEmailLog(item);
                              }}
                            >
                              <IncomingEmailIcon/>
                            </span>
                            </Tooltip>
                        ) }
                      </>
                    )}
                     {item?.ticketLogChanges?.length > 0 && (
                       <Tooltip title="Change log" placement="right" arrow>
                      <span style={{position:'relative',top:'5px',left:'30px'}}
                        onClick={() => {
                          setShowticketLog(true);
                          setSelectedLog(item);
                        }}
                      >
                        <ChangeHistoryIcon
                          sx={{
                            color: "red",
                            paddingRight: "5px",
                            cursor: "pointer",
                          }}
                        />
                      </span>
                      </Tooltip>
                    )}
                  </Typography>

                  <Typography
                    fontWeight={500}
                    sx={{ wordBreak: "break-word",mb:1,mr:0.5 }}
                  >
                    {item.title}
                  </Typography>

                  <Typography
                    variant="caption"
                    color="text.secondary"
                  >
                    {ConvertZ(
                      item.createdDateTime,
                      "DD/MM/YYYY HH:mm"
                    )}
                  </Typography>
                  <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.5,
                    p: 1,
                    maxWidth:'90%'
                  }}
                >
                  {item?.ticketLogAttachments?.map((item: any) => {
                 const fileName = item?.AttachmentPath?.split("/").pop()?.replace(/^[0-9a-f-]+-/, "");

                    const ext = fileName?.split(".").pop()?.toLowerCase();
                   let icon;
                    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) {
                      icon = <ImageIcon />;
                    } else if (ext === "pdf") {
                      icon = <PictureAsPdfIcon />;
                    } else if (["doc", "docx"].includes(ext)) {
                      icon = <DescriptionIcon />;
                    } else {
                      icon = <InsertDriveFileIcon />;
                    }

                    return (
                      <Chip
                        key={item.id}
                        icon={icon}
                        label={fileName}
                        clickable
                        onClick={() => window.open(item?.AttachmentPath, "_blank")}
                        sx={{
                          maxWidth: "200px",
                          borderRadius: "8px",
                          border: "1px solid #1976d2",
                          color: "#1976d2",
                          backgroundColor: "#f5f9ff",
                          "& .MuiChip-icon": {
                            color: "#1976d2",
                          },
                        }}
                      />
                    );
                  })}
                </Box>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={1.5} sx={{ ml: { xs: 2.6, md: 0 }, borderLeft: { xs: "2px solid lightgray", md: "none" }}}>
              <Box
                display="flex"
                alignItems="center"
                gap={1}
                flexWrap="wrap"
              >
                <Avatar sx={{ bgcolor: "#1976d2" }}>
                  {getAvatarText(item)}
                </Avatar>

                <Box>
                  <Typography
                    fontWeight={500}
                    sx={{ wordBreak: "break-word" }}
                  >
                    {(item?.userType == "BusinessRule" ||
                    item?.userType == "Workflow")
                      ? ""
                      : (item.updatedBy ?? item.contactName)?.split(" ")[0]}
                  </Typography>

                  <Typography variant="caption">
                    ({item.userType || "N/A"})
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={2} sx={{ ml: { xs: 2.6, md: 0 }, borderLeft: { xs: "2px solid lightgray", md: "none" },borderRight: { md: "1px solid lightgray", xs: "none" } }}>
              <Box>
                {/* <Typography variant="body2">
                  <b>First Action Date:</b> 
                </Typography> */}

                <Typography variant="body2" mt={0.5}>
                  <b>Status:</b>{" "}
                  <Chip
                    size="small"
                    label={item.statusName}
                    color="primary"
                  />
                </Typography>

                <Typography variant="body2" mt={0.5}>
                  <b>Owner:</b> {item.owner || "-"}
                </Typography>

                <Typography variant="body2" mt={0.5}>
                  <b>Effort : </b>
                   <span
                    className="timeline-effort"
                    style={{ color: "#2F80ED" }}
                  >
                    {timeSpanToReadbleFormat(
                      item?.effort,
                      "effort"
                    )}
                  </span>
                </Typography>

                {/* <Typography variant="body2" mt={0.5}>
                  <b>Down Time:</b> {}
                </Typography> */}

              </Box>
            </Grid>
          <Grid item xs={12} md={5} sx={{ ml: { xs: 2.6, md: 0 }, borderLeft: { xs: "2px solid lightgray", md: "none" }, }}>
              <Box
                display="flex"
                alignItems="center"
                gap={1}
                flexWrap="wrap"
              >
                <Box sx={{width: {sx:"80%",md:"100%"}}}>
                  {item?.note && (
                    <Typography
                      fontWeight={500}
                      sx={{ wordBreak: "break-word" }}
                    >
                      <b>{item?.statusId == 6 ? 'Solution' : 'Note'}  </b> <br/>  {item.note.split(" ").map((word:any) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")}
                    </Typography>
                  )}
                   {content && (
                  <Box mt={2} > 
                    {isHTML(content) ? (
                      <Box
                        sx={{
                          borderRadius: 1,
                          overflow: "hidden",
                          width: "100%",
                        }}
                      >
                            <Typography variant="body2" mt={0.5} sx={{fontSize:'16px'}}>
                            <b>Email Body :</b>
                          </Typography>
                        <RichEmailPreviewer
                          body={content}
                          height={260}
                        />
                      </Box>
                    ) : (
                      <Typography
                        sx={{ wordBreak: "break-word" }}
                      >
                        <b>Description </b> <br/> {content}
                      </Typography>
                    )}
                  </Box>
                )}
                </Box>
              </Box>
            </Grid>
           
          </Grid>
        );
      })}
    </Box>
  );
};

export default SSPTimeline;